module.exports = "\n    <div class=\"message\">\n        <span>{{ data }}</span>\n    </div>\n"